<div class="absolute bottom-0 left-0 right-0 p-3">
  <div class="relative">
      <button (click)="toggleUserDropdown($event)" class="w-full flex items-center sidebar-text hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg p-1 -m-1 transition-colors" aria-label="User menu" aria-haspopup="true" [attr.aria-expanded]="isUserDropdownOpen">
        <img [src]="userProfile.avatarUrl?.replace('background=4f46e5', 'background=%231800add1')" [alt]="userProfile.name" class="user-footer-avatar w-10 h-10 rounded-full ring-2 ring-white dark:ring-slate-700 flex-shrink-0">
        <div class="ml-3 flex-1 min-w-0 text-left">
          <p class="text-sm font-semibold text-gray-900 dark:text-white truncate mb-0">{{ userProfile.name }}</p>
          <p class="text-xs text-gray-500 dark:text-gray-400 truncate mb-0">{{ userProfile.email }}</p>
        </div>
        <i class="fas fa-chevron-up text-xs text-gray-400 ml-2" aria-hidden="true"></i>
      </button>
    
    <!-- Collapsed user avatar button -->
    <button (click)="toggleUserDropdown($event)" class="hidden sidebar-collapsed-show w-full justify-center hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg p-1 transition-colors" aria-label="User menu">
      <img [src]="userProfile.avatarUrl" [alt]="userProfile.name" class="user-footer-avatar w-10 h-10 rounded-full ring-2 ring-white dark:ring-slate-700">
    </button>
    

    <!-- Dropdown Menu (opens upward) -->
    <div 
      [class.hidden]="!isUserDropdownOpen" 
      class="absolute bottom-full left-0 right-0 mb-2 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-gray-200 dark:border-slate-700 py-2 z-50 fade-in" 
      role="menu" 
      [attr.aria-label]="'COMMON.USER_MENU' | translate"
    >


      <!-- Sign Out -->
      <button 
        (click)="onMenuAction('sign-out'); isUserDropdownOpen = false"
        class="w-full flex items-center px-4 py-2.5 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20"
        role="menuitem"
      >
        <i class="fas fa-sign-out-alt w-5 mr-3 "></i>
         <span class="signout-text">{{ 'COMMON.SIGN_OUT' | translate }}</span>
      </button>


    </div>

  </div>
</div>



